import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip, TooltipProps } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import styles from "./styles";

type Props = Omit<TooltipProps, "title" | "children"> & {
  text: string;
  size?: "small" | "medium" | "large";
  color?: string;
};

const Help: FC<Props> = ({ text, size = "medium", color = "var(--color-blue)", ...rest }) => {
  const { t } = useTranslation();
  const wh = size === "small" ? 16 : size === "large" ? 24 : 20;

  return (
    <Tooltip
      title={<div dangerouslySetInnerHTML={{ __html: t(text) }} />}
      arrow
      disableInteractive
      PopperProps={{ sx: styles.popper }}
      {...rest}
      className="RlxHelp"
    >
      <HelpIcon sx={{ width: wh, height: wh, color, cursor: "help" }} />
    </Tooltip>
  );
};

Help.displayName = "Help";

export default memo(Help);
